import React, { useState,useEffect } from "react";
import { IoLinkSharp } from "react-icons/io5";
import { IoMdArrowDropdown,IoMdArrowDropright } from "react-icons/io";
import { TbExternalLink } from "react-icons/tb";
import { BiSolidTrash,BiPencil } from "react-icons/bi";
import { Button, ListGroup, Container } from "react-bootstrap";
import AddUpdateLinkModal from "./modals/AddUpdateLinksModal";
import { deleteWorkstreamLinks,deleteProjectLinks,getWorkstreamLinks,getProjectLinks } from "../api/Api";
import { showToast } from "../utils/toastUtils";
import CustomButton from "./CustomButton";
import DeleteModel from "./modals/DeleteModel";
import DeleteIcon from "./Inputs/DeleteIcon";
import {Header} from "../pages/Home";



const AddLinks = ({ entityId, entityType }) => {
  const [showModal, setShowModal] = useState(false);
  const [expandedLinks, setExpandedLinks] = useState({}); 
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedLink, setSelectedLink] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false); 
  const [linkToDelete, setLinkToDelete] = useState(null);  


 useEffect(() => {
    const fetchLinks = async () => {
      try {
        setLoading(true);
        setError(null);
        let fetchedLinks = [];

        if (entityType === "initiative") {
             const response = await getWorkstreamLinks(entityId);
             fetchedLinks = response.data || [];
        } else if (entityType === "project") {
              const response = await getProjectLinks(entityId);
              fetchedLinks = response.data || [];
        }
        setLinks(fetchedLinks);
      } catch (err) {
        console.error("Error fetching links:", err);
        setError(err.message || "Failed to load links.");
        showToast("Failed to load links", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchLinks();
  }, [entityId, entityType, refreshKey]);


  const refresh = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const handleEdit = (link) => {
    setSelectedLink(link); 
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      if (entityType === "initiative") {
        await deleteWorkstreamLinks(entityId,linkToDelete);
      } else if (entityType === "project") {
        await deleteProjectLinks(entityId, linkToDelete);
      }
      showToast("Link deleted successfully", "success");
      refresh();
    } catch (error) {
      console.error("Error deleting link:", error);
      showToast("Failed to delete link", "error");
    }finally
    {
      setShowDeleteModal(false);
    }
  };

   const toggleExpand = (linkId) => {
    setExpandedLinks((prev) => ({
      ...prev,
      [linkId]: !prev[linkId], // Toggle expansion state
    }));
  };

  const confirmDelete = (linkId) => {
    setLinkToDelete(linkId); // Set the link to delete
    setShowDeleteModal(true); // Open the delete modal
  };


  return (
    <div className="mt-5 pb-3 rounded-4 primary-box">
      <Header
        title="Links"
        icon={<IoLinkSharp size={30} c />}
        onButtonClick={() => {  
          setSelectedLink(null); // Reset selected link for adding a new one
          setShowModal(true); // Open the modal
        }}
        buttonTitle="Add Link"
        />
       <ListGroup className="mt-3">
        {loading ? (
          <p className="d-flex justify-content-center">Loading...</p>
        ) : error ? (
          <p className="d-flex justify-content-center text-danger">{error}</p>
        ) : links && links.length > 0 ? (
          links.map((link) => (
            <ListGroup.Item
              key={link.id}
              className="d-flex d-sm-flex flex-column flex-sm-row align-items-center gap-0 px-5 py-2 mt-2 mb-2 mx-3"
              style={{
                border: "1px solid #f0efef",
                background: "#fafafa",
                borderRadius: "10px",
                maxWidth: "100%",
              }}
            >
            <div className="col-9 col-sm-10  py-3">
              {/* Toggle icon */}
              <div className="d-flex align-items-center gap-2">
              <span onClick={() => toggleExpand(link.id)} style={{ cursor: "pointer" }}>
                {expandedLinks[link.id] ? (
                  <IoMdArrowDropdown size={25} />
                ) : (
                  <IoMdArrowDropright size={25} />
                )}
              </span>
              <div className="d-block">
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer", 
                  maxWidth: "100%", 
                  wordBreak: "break-word",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
                onClick={() => toggleExpand(link.id)} 
              >
                {link.title}
              </span>
              </div>
              </div>
              {/* Show description with rich text when expanded */}
              {expandedLinks[link.id] && (
                <div
                  style={{
                  fontSize: "16px",
                  maxWidth: "100%", 
                  wordBreak: "break-word",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  }}
                  className="mx-4 mt-2"
                >
                  <div
                    dangerouslySetInnerHTML={{ __html: link.description }} // Render rich text safely
                  />
                </div>
              )}
            </div>
          
              <div className="d-flex col-2 sm-col-2 md-col-2 justify-content-end align-items-center gap-3 ">
                <div className="d-flex align-items-center">
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    <Button
                      className="rounded-circle d-flex align-items-center justify-content-center p-1"
                      style={{ borderColor: "#1ccbdf", color: "#1ecae0", background: "transparent" }}
                    >
                      <TbExternalLink size={22} color="#1099d8" />
                    </Button>
                  </a>
                </div>
                 {/* Edit Button */}
                <Button
                  variant="outline-secondary"
                  className="rounded-circle d-flex align-items-center justify-content-center p-2"
                  onClick={() => handleEdit(link)}
                  style={{ borderColor: "#1ecae0", color: "#1ecae0", background: "transparent" }}
                >
                  <BiPencil size={16} />
                </Button>
                 <DeleteIcon onDelete={() => confirmDelete(link.id)} />
              </div>

            </ListGroup.Item>
          ))
        ) : (
          <p className="d-flex justify-content-center">No links available.</p>
        )}
      </ListGroup>

       <AddUpdateLinkModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        refreshLinks={refresh}
        entityType={entityType}
        entityId={entityId}
        link={selectedLink} // Pass the selected link for editing
      />

      {/* Delete Confirmation Modal */}
      <DeleteModel
        open={showDeleteModal}
        closeAlert={() => setShowDeleteModal(false)}
        onClick={handleDelete}
        type="link"
      />
    </div>
  );
};

export default AddLinks;
